import { CookiePolicy } from '@/features/consumer/cookie-policy';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_public/cookie-policy')({
  component: CookiePolicy,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      embed: (search.embed as string) || undefined,
    };
  },
});
